import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './services/user/user.service';

import * as SurveyKnockout from "survey-knockout";
import * as SurveyAngular from "survey-angular";

import * as autodateWidget from "./components/survey-creator/widgets/autoDate";
import * as photoWidget from "./components/survey-creator/widgets/photo";
import * as barcodeScannerWidget from "./components/survey-creator/widgets/barcodeScanner";
import * as timePickerWidget from "./components/survey-creator/widgets/timePicker";
import * as extraRecipient from "./components/survey-creator/widgets/extraRecipient";
import * as sequentialNumbering from "./components/survey-creator/widgets/sequentialNumbering";
import { ModalService } from './shared/modal.service';

const split = (params) => {
  try{
    if (!params) {
      return '';
    }
    if (params.length === 1 && params[0]) {
      return params[0];
    }
    if (params.length === 2 && params[0] && params[1]) {
      return params[0].split(params[1]);
    }
    if (params.length === 3 && params[0] && params[1] && (params[2] !== null || params[2] !== undefined)) {
      return params[0].split(params[1])[params[2]];
    }
  } catch (err) {
  }
  return ' ';
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent{

  user:any=null;

  constructor(private router: Router, private userService: UserService) {
    (window as any).pathHash = window.location.hash;
    console.log(window.location.hash);

    let user = localStorage.getItem('user');
    if(user == null)
    {
        this.router.navigate(['login']);
    }else
    {
        this.router.navigate(['records']);
    }

    this.registerCustomWidgets();
  }

  registerCustomWidgets(){
    photoWidget.init(SurveyKnockout);
    autodateWidget.init(SurveyKnockout);
    barcodeScannerWidget.init(SurveyKnockout);
    timePickerWidget.init(SurveyKnockout);
    extraRecipient.init(SurveyKnockout);
    sequentialNumbering.init(SurveyKnockout);

    photoWidget.init(SurveyAngular);
    autodateWidget.init(SurveyAngular);
    barcodeScannerWidget.init(SurveyAngular);
    timePickerWidget.init(SurveyAngular);
    extraRecipient.init(SurveyAngular);
    sequentialNumbering.init(SurveyAngular);

    SurveyKnockout
      .FunctionFactory
      .Instance
      .register('split', split);
    SurveyAngular
      .FunctionFactory
      .Instance
      .register('split', split);


    SurveyKnockout
      .Serializer
      .addProperty("question", {
        name: "customColumn:boolean",
        default: false,
        category: "general"
      });

    SurveyKnockout
    .Serializer
    .addProperty("question", {
      name: "columnName:string",
      default: "",
      category: "general"
    });

    SurveyKnockout
    .Serializer
    .addProperty("question", {
      name: "valuePath:string",
      default: "",
      category: "general"
    });

    SurveyKnockout
    .Serializer
    .addProperty("question", {
      name: "portalOnly:boolean",
      default: false,
      category: "general"
    });

    SurveyKnockout
    .Serializer
    .addProperty("dropdown",
    {
      name: "dynamicDropdown:boolean",
      default: false,
      category: "general",
    });

  }
}

